import {
	generateLegendArray,
	GenerateLegendArrayArgs,
} from 'areas/metrics/components/MetricLegendSelect/utils/generateLegendArray';

export type GenerateLegendStringArgs = GenerateLegendArrayArgs & {
	delimiter?: string;
};

export function generateLegendString(args: GenerateLegendStringArgs) {
	if (args.data?.configuration) {
		args.data = { ...args.data, ...args.data.configuration };
	}
	return generateLegendArray(args)
		.filter((x) => !!x?.trim())
		.join(args.delimiter ?? ' / ');
}
